import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PublicLayout } from './layouts/PublicLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { DashboardHome } from './pages/DashboardHome';
import { ProfilePage } from './pages/dashboard/ProfilePage';
import { MyPropertiesPage } from './pages/dashboard/MyPropertiesPage';
import { MyAuctionsPage } from './pages/dashboard/MyAuctionsPage';
import { MyWalletPage } from './pages/dashboard/MyWalletPage';
import { MyNotificationsPage } from './pages/dashboard/MyNotificationsPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { AuctionsPage } from './pages/AuctionsPage';
import { AuctionRoomPage } from './pages/AuctionRoomPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { BrokersPage } from './pages/BrokersPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { AdminPropertiesPage } from './pages/admin/AdminPropertiesPage';
import { AdminAuctionsPage } from './pages/admin/AdminAuctionsPage';
import { AdminAuctionRequestsPage } from './pages/admin/AdminAuctionRequestsPage';
import { AdminProfileChangesPage } from './pages/admin/AdminProfileChangesPage';
import { AdminInvitationsPage } from './pages/admin/AdminInvitationsPage';
import { AdminDiscountCodesPage } from './pages/admin/AdminDiscountCodesPage';
import { AdminPaymentsPage } from './pages/admin/AdminPaymentsPage';
import { SubscriptionPage } from './pages/dashboard/SubscriptionPage';
import { AdminBrokersPage } from './pages/admin/AdminBrokersPage';
import { AdminUnionsPage } from './pages/admin/AdminUnionsPage';
import { AdminFacilityPage } from './pages/admin/AdminFacilityPage';
import { AdminAssociationsPage } from './pages/admin/AdminAssociationsPage';
import { AdminAssociationDetailPage } from './pages/admin/AdminAssociationDetailPage';
import { AdminCompaniesPage } from './pages/admin/AdminCompaniesPage';
import { AdminIntegrationsPage } from './pages/admin/AdminIntegrationsPage';
import { AdminMessagesLogPage } from './pages/admin/AdminMessagesLogPage';
import { MyAssociationsPage } from './pages/dashboard/MyAssociationsPage';
import { AssociationPage } from './pages/AssociationPage';
import { AssociationSubscriptionPage } from './pages/AssociationSubscriptionPage';
import { AssociationJoinPage } from './pages/AssociationJoinPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { CopyrightPage } from './pages/CopyrightPage';
import { CredentialsPage } from './pages/CredentialsPage';
import { AdminCredentialsPage } from './pages/admin/AdminCredentialsPage';
import { ComplaintsPage } from './pages/ComplaintsPage';
import { ComplaintTrackPage } from './pages/ComplaintTrackPage';
import { AdminComplaintsPage } from './pages/admin/AdminComplaintsPage';
import { NafathVerifyPage } from './pages/NafathVerifyPage';
import { MullakLandingPage } from './pages/MullakLandingPage';
import { EngineeringDesignPage } from './pages/EngineeringDesignPage';
import { CalculatorsPage } from './pages/CalculatorsPage';
import { MyFavoritesPage } from './pages/dashboard/MyFavoritesPage';
import { MyAlertsPage } from './pages/dashboard/MyAlertsPage';
import { MyRequestsPage } from './pages/dashboard/MyRequestsPage';
import { AdminContentPage } from './pages/admin/AdminContentPage';
import { PropertiesMapPage } from './pages/PropertiesMapPage';
import { AdminRequestsPage } from './pages/admin/AdminRequestsPage';
import { AdminMessagesPage } from './pages/admin/AdminMessagesPage';
import { AdminSettingsPage } from './pages/admin/AdminSettingsPage';
import { AdminActivityLogPage } from './pages/admin/AdminActivityLogPage';
import { RequestAuctionPage } from './pages/RequestAuctionPage';
import { SubmitPropertyPage } from './pages/SubmitPropertyPage';
import { AdminFalLicensesPage } from './pages/admin/AdminFalLicensesPage';
import { CompliancePage } from './pages/CompliancePage';
import { BecomeBrokerPage } from './pages/BecomeBrokerPage';

export const router = createBrowserRouter([
  // 🌍 المسارات العامة (مع Header + Footer)
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'properties',     element: <PropertiesPage /> },
      { path: 'properties/:id', element: <PropertyDetailPage /> },
      { path: 'auctions',         element: <AuctionsPage /> },
      { path: 'request-auction',  element: <RequestAuctionPage /> },
      { path: 'submit-property',  element: <SubmitPropertyPage /> },
      { path: 'add-property',     element: <SubmitPropertyPage /> },
      { path: 'compliance',       element: <CompliancePage /> },
      { path: 'rega-compliance',  element: <CompliancePage /> },
      { path: 'brokers',        element: <BrokersPage /> },
      { path: 'become-broker',  element: <BecomeBrokerPage /> },
      { path: 'apply-broker',   element: <BecomeBrokerPage /> },
      { path: 'contact',        element: <ContactPage /> },
      { path: 'about',          element: <AboutPage /> },
      { path: 'terms',          element: <TermsPage /> },
      { path: 'privacy',        element: <PrivacyPage /> },
      { path: 'copyright',      element: <CopyrightPage /> },
      { path: 'credentials',    element: <CredentialsPage /> },
      { path: 'complaints',     element: <ComplaintsPage /> },
      { path: 'complaints/track/:ticket', element: <ComplaintTrackPage /> },
      { path: 'design',         element: <EngineeringDesignPage /> },
      { path: 'engineering',    element: <EngineeringDesignPage /> },
      { path: 'mullak',         element: <MullakLandingPage /> },
      { path: 'owners-association', element: <MullakLandingPage /> },
      { path: 'calculators',    element: <CalculatorsPage /> },
      { path: 'tools',          element: <CalculatorsPage /> },
      { path: 'map',            element: <PropertiesMapPage /> },
      { path: 'properties-map', element: <PropertiesMapPage /> },
    ],
  },

  // 🔐 صفحات التوثيق (بدون header)
  { path: '/login',           element: <LoginPage /> },
  { path: '/verify-nafath',   element: <NafathVerifyPage /> },
  { path: '/register',        element: <RegisterPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password',  element: <ResetPasswordPage /> },

  // 🎙️ غرفة المزاد المباشر (شاشة كاملة بدون header)
  { path: '/auctions/:id', element: <AuctionRoomPage /> },

  // 🔑 رابط الانضمام لجمعية (لازم يكون قبل /associations/:slug)
  { path: '/associations/join/:token', element: <AssociationJoinPage /> },

  // 🏛️ صفحة الجمعية المنفصلة (واجهة فريدة بالـ slug — هويتها الخاصة)
  { path: '/associations/:slug', element: <AssociationPage /> },
  { path: '/a/:associationId/subscription', element: <AssociationSubscriptionPage /> },

  // 👤 لوحة المستخدم (مصادقة مطلوبة)
  {
    path: '/dashboard',
    element: <AuthLayout />,
    children: [
      { index: true,             element: <DashboardHome /> },
      { path: 'profile',         element: <ProfilePage /> },
      { path: 'properties',      element: <MyPropertiesPage /> },
      { path: 'auctions',        element: <MyAuctionsPage /> },
      { path: 'wallet',          element: <MyWalletPage /> },
      { path: 'notifications',   element: <MyNotificationsPage /> },
      { path: 'subscription',    element: <SubscriptionPage /> },
      { path: 'my-associations', element: <MyAssociationsPage /> },
      { path: 'favorites',       element: <MyFavoritesPage /> },
      { path: 'alerts',          element: <MyAlertsPage /> },
      { path: 'requests',        element: <MyRequestsPage /> },
    ],
  },

  // 👑 لوحة الإدارة (ADMIN/SUPER_ADMIN فقط)
  {
    path: '/admin',
    element: <AuthLayout allowedRoles={['ADMIN', 'SUPER_ADMIN']} />,
    children: [
      { index: true,        element: <AdminDashboard /> },
      { path: 'users',      element: <AdminUsersPage /> },
      { path: 'properties', element: <AdminPropertiesPage /> },
      { path: 'auctions',         element: <AdminAuctionsPage /> },
      { path: 'auction-requests', element: <AdminAuctionRequestsPage /> },
      { path: 'profile-changes',  element: <AdminProfileChangesPage /> },
      { path: 'fal-licenses',     element: <AdminFalLicensesPage /> },
      { path: 'invitations',      element: <AdminInvitationsPage /> },
      { path: 'discount-codes',   element: <AdminDiscountCodesPage /> },
      { path: 'payments',         element: <AdminPaymentsPage /> },
      { path: 'brokers',          element: <AdminBrokersPage /> },
      { path: 'unions',           element: <AdminUnionsPage /> },
      { path: 'facility',         element: <AdminFacilityPage /> },
      { path: 'associations',     element: <AdminAssociationsPage /> },
      { path: 'associations/:id', element: <AdminAssociationDetailPage /> },
      { path: 'companies',        element: <AdminCompaniesPage /> },
      { path: 'integrations',     element: <AdminIntegrationsPage /> },
      { path: 'messages-log',     element: <AdminMessagesLogPage /> },
      { path: 'content',          element: <AdminContentPage /> },
      { path: 'requests',         element: <AdminRequestsPage /> },
      { path: 'messages',     element: <AdminMessagesPage /> },
      { path: 'activity-log', element: <AdminActivityLogPage /> },
      { path: 'credentials',  element: <AdminCredentialsPage /> },
      { path: 'complaints',   element: <AdminComplaintsPage /> },
      { path: 'settings',     element: <AdminSettingsPage /> },
    ],
  },

  // 🚫 404
  { path: '*', element: <Navigate to="/" replace /> },
]);
